/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['assets/js/backbone-extended', 'assets/js/modules/designFacePreview/model/productPreviewInfoModel'], function(
    backboneExtended,
    ProductPreviewInfoModel
) {
    return backboneExtended.NestedModel.extend({
        relations: {
            productPreviewInfo: ProductPreviewInfoModel
        },
        defaults: {
            productSlug: null,
            linearUnitSign: '',
            hasTrimLine: false
        }
    });
});
